export default __webpack_public_path__ + "static/media/fw-amelia-er-Yellow Gold.9eda7d4b.mp4";